import React from 'react';
import { Page, Text, View, Font, Document } from '@react-pdf/renderer';

import { registerPdfFonts } from '../../../lib/registerPdfFonts';
import PrintableHeader from './components/PrintableHeader';
import BlankQuestionsSection from './components/BlankQuestionsSection';
import PdfFormattedText from './components/PdfFormattedText';
import { LibraryFormAssessment } from './helpers';
import { pageStyles } from './styles';

// Register fonts on this module's @react-pdf/renderer instance before BlobProvider
// generates the PDF. The shared registerPdfFonts module uses a different Font
// singleton when webpack splits the Library chunk from the app entry bundle.
registerPdfFonts(Font);

const LibraryFormPDF: React.FC<{
  assessment: LibraryFormAssessment;
  wordmarkLogoUrl?: string | null;
}> = ({ assessment, wordmarkLogoUrl }) => (
  <Document>
    <Page size="A4" style={pageStyles.page}>
      <View>
        <PrintableHeader wordmarkLogoUrl={wordmarkLogoUrl} />

        <Text style={pageStyles.title}>{assessment.name}</Text>

        {assessment.instructions ? (
          <View>
            <Text style={pageStyles.sectionTitle}>Instructions</Text>
            <PdfFormattedText style={pageStyles.instructions}>
              {assessment.instructions}
            </PdfFormattedText>
          </View>
        ) : null}

        {assessment.questionFrame ? (
          <PdfFormattedText style={pageStyles.questionFrame}>
            {assessment.questionFrame}
          </PdfFormattedText>
        ) : null}

        <BlankQuestionsSection questions={assessment.questions} />
      </View>
    </Page>
  </Document>
);

export default LibraryFormPDF;
